var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 18,
    viewBox: "0 0 5 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 15.25C4.375 15.7473 4.17746 16.2242 3.82583 16.5758C3.47419 16.9275 2.99728 17.125 2.5 17.125C2.00272 17.125 1.52581 16.9275 1.17417 16.5758C0.822544 16.2242 0.625 15.7473 0.625 15.25C0.625 14.7527 0.822544 14.2758 1.17417 13.9242C1.52581 13.5725 2.00272 13.375 2.5 13.375C2.99728 13.375 3.47419 13.5725 3.82583 13.9242C4.17746 14.2758 4.375 14.7527 4.375 15.25ZM4.375 9C4.375 9.49728 4.17746 9.97419 3.82583 10.3258C3.47419 10.6775 2.99728 10.875 2.5 10.875C2.00272 10.875 1.52581 10.6775 1.17417 10.3258C0.822544 9.97419 0.625 9.49728 0.625 9C0.625 8.50272 0.822544 8.0258 1.17417 7.67417C1.52581 7.32254 2.00272 7.125 2.5 7.125C2.99728 7.125 3.47419 7.32254 3.82583 7.67417C4.17746 8.0258 4.375 8.50272 4.375 9ZM4.375 2.75C4.375 3.24728 4.17746 3.72419 3.82583 4.07583C3.47419 4.42746 2.99728 4.625 2.5 4.625C2.00272 4.625 1.52581 4.42746 1.17417 4.07583C0.822544 3.72419 0.625 3.24728 0.625 2.75C0.625 2.25272 0.822544 1.77581 1.17417 1.42417C1.52581 1.07254 2.00272 0.875 2.5 0.875C2.99728 0.875 3.47419 1.07254 3.82583 1.42417C4.17746 1.77581 4.375 2.25272 4.375 2.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.0056a178ca40ada32ecf12f6db055780.svg";
export { ForwardRef as ReactComponent };